import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import LoadingSpinner from './LoadingSpinner';

/**
 * Route guard for the admin console.
 * Allows any user holding a staff role (owner | admin | editor | support);
 * `is_admin` is honored for backward compatibility. Per-section rights come
 * from the RBAC matrix (see docs/admin-portal-refactor.md).
 * - unauthenticated → /login?next=<current path>
 * - authenticated non-staff → /dashboard (not a 404 — they're just not staff)
 */
export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  const isStaff = Boolean(user?.staff_role) || Boolean(user?.is_admin);
  if (!isStaff) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
